import {
  CONV_STARTER_ACTION_TYPES,
  EXTENSION_ACTIONS,
  ONBOARDING_HOOKS_ACTION_TYPES,
} from '~/constants';
import { REDIRECT } from '~/constants/redirect';

export interface IExtensionMessage {
  action: EXTENSION_ACTIONS;
  data: unknown;
  destination: keyof typeof REDIRECT;
}

export const CONV_STARTER_ACTION = 'CONV_STARTER_ACTION' as const;

export type ConvStarterActionTypes =
  | (typeof CONV_STARTER_ACTION_TYPES)[keyof typeof CONV_STARTER_ACTION_TYPES]
  | (typeof ONBOARDING_HOOKS_ACTION_TYPES)[keyof typeof ONBOARDING_HOOKS_ACTION_TYPES];

export type StarterData<StarterType extends ConvStarterActionTypes> =
  StarterType extends typeof CONV_STARTER_ACTION_TYPES.prep1on1Chat
    ? {
        id: string;
        fullName: string;
        slug: string;
      }
    : StarterType extends typeof CONV_STARTER_ACTION_TYPES.mentionedBrandsChat
      ? {
          id: string;
          fullName: string;
          slug: string;
        }
      : StarterType extends typeof CONV_STARTER_ACTION_TYPES.draftEmailPitchChat
        ? {
            id: string;
            fullName: string;
            slug: string;
          }
        : StarterType extends typeof ONBOARDING_HOOKS_ACTION_TYPES.viewSimilarPostsHook
          ? {
              id: string;
              slug: string;
              fullName: string;
              contentId: string;
              contentCaptions: string;
            }
          : StarterType extends typeof ONBOARDING_HOOKS_ACTION_TYPES.analyzeContentHook
            ? {
                id: string;
                fullName: string;
                slug: string;
              }
            : StarterType extends typeof ONBOARDING_HOOKS_ACTION_TYPES.avgViewsCustomHook
              ? {
                  id: string;
                  fullName: string;
                  slug: string;
                  platforms: string[];
                }
              : StarterType extends typeof ONBOARDING_HOOKS_ACTION_TYPES.mentionedBrandsHook
                ? {
                    id: string;
                    fullName: string;
                    slug: string;
                  }
                : StarterType extends typeof ONBOARDING_HOOKS_ACTION_TYPES.prep1on1Hook
                  ? {
                      id: string;
                      fullName: string;
                      slug: string;
                    }
                  : StarterType extends typeof ONBOARDING_HOOKS_ACTION_TYPES.recommendedBrandPartnersHook
                    ? {
                        id: string;
                        fullName: string;
                        slug: string;
                      }
                    : StarterType extends typeof ONBOARDING_HOOKS_ACTION_TYPES.enhanceSearchHook
                      ? {
                          keywords: string;
                        }
                      : never;
